import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    root: {
        display: "flex",
    },
    rootList: {
        overflowX: "hidden",
        display: "flex",
    },
    content: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: theme.palette.primary.primary0,
        padding: theme.spacing(2),
    },
    contentList: {
        flexGrow: 1,
        backgroundColor: "#f7f8fc",
        padding: theme.spacing(2),
    },
    largeDrawerContent: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: theme.palette.primary.primary0,
        padding: theme.spacing(2),
    },
    contentNoPadding: {
        flexGrow: 1,
        backgroundColor: "#f7f8fc",
    },
    largeDrawerContentList: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: "#F7F8FC",
        padding: theme.spacing(2),
    },
    largeDrawerContentNoPadding: {
        flexGrow: 1,
        minHeight: "100vh",
        backgroundColor: "#F7F8FC",
    },
    largeDrawerContentNoPaddingEmbeddable: {
      flexGrow: 1,
      minHeight: "100vh",
      backgroundColor: "#F2F3F7",
    },
    toolbar: theme.mixins.toolbar,
}));

export default useStyles;
